import { SimpleGrid, Stack, Text } from '@mantine/core';
import { ReactNode } from 'react';
import { AppTooltip } from '../../../common/AppTooltip';

export interface MetricItem {
  label: string;
  labelTooltip?: string;
  value: ReactNode;
  sublabel?: ReactNode;
}

export function MetricRow({ items }: { items: MetricItem[] }) {
  const cols = Math.max(1, Math.min(items.length, 4));

  return (
    <SimpleGrid
      cols={cols}
      spacing="md"
      breakpoints={[
        ...(cols === 4 ? [{ maxWidth: 1100, cols: 2 } as const] : []),
        { maxWidth: 700, cols: 1 },
      ]}
    >
      {items.map((item, idx) => (
        <Stack key={idx} spacing={2}>
          {item.labelTooltip ? (
            <AppTooltip label={item.labelTooltip} inline>
              <Text
                size="xs"
                color="dimmed"
                component="span"
                sx={{
                  cursor: 'help',
                  textDecoration: 'underline dotted',
                  textUnderlineOffset: 2,
                  display: 'inline-flex',
                  width: 'fit-content',
                }}
              >
                {item.label}
              </Text>
            </AppTooltip>
          ) : (
            <Text size="xs" color="dimmed">
              {item.label}
            </Text>
          )}
          <div>{item.value}</div>
          {item.sublabel ? (
            <Text size="xs" color="dimmed">
              {item.sublabel}
            </Text>
          ) : null}
        </Stack>
      ))}
    </SimpleGrid>
  );
}
